import $ from 'jquery';
import MicroModal from 'micromodal';

const options = {
  onShow: (modal) => {
    history.replaceState(null, null, `#${modal.id}`);
  },
  onClose: (modal) => {
    history.replaceState(null, null, '#');
  },
  openTrigger: 'data-modal-open',
  closeTrigger: 'data-modal-close',
  disableScroll: true,
  disableFocus: true,
  awaitCloseAnimation: true,
};

const $document = $(document);
const $body = $('body');
const $modals = $('.js-modal');

// Append modals to end of </body>, to avoid issues with position: relative
// parent elements (eg. Flickity carousels).
$body.append($modals);

$modals.each((index, modal) => {
  const $modal = $(modal);
  const id = $modal.attr('id');
  $document.on('click', `a[href="#${id}"]`, (event) => {
    event.preventDefault();
    MicroModal.show(id, options);
  });
});

window.addEventListener('DOMContentLoaded', () => {
  const id = window.location.hash.slice(1);
  if ($modals.filter(`[id="${id}"]`).length) {
    MicroModal.show(id, options);
  }
});
